import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Button, Icon, Modal } from "semantic-ui-react";

import "modules/WarrantyDashboard/components/WarrantyExportModal/WarrantyExportModal.scss";
import { setIsExportModalOpen, useExportWarrantyDashboard, useGetWarrantyDashboardFilters, useIsExportModalOpen } from "modules/WarrantyDashboard/hooks";

export const WarrantyExportModal = () => {
  const { t } = useTranslation();

  const isExportModalOpen = useIsExportModalOpen();
  const { filters } = useGetWarrantyDashboardFilters();
  const { mutate: queueWarrantyExport, isPending, isSuccess, isError } = useExportWarrantyDashboard();

  useEffect(() => {
    if (isExportModalOpen) queueWarrantyExport(filters);
  }, [isExportModalOpen]);

  const handleCloseExportModal = () => setIsExportModalOpen(false);

  return (
    <Modal size="tiny" open={isExportModalOpen} onClose={handleCloseExportModal} className="WarrantyExportModal">
      <Modal.Header>
        <div className="WarrantyExportModal__export-file-container">
          <div>
            <Icon className="file" />
            <span> {t("v8_export", "Export")} </span>
          </div>

          <div className="WarrantyExportModal__export-modal-button-container">
            <Button basic icon onClick={handleCloseExportModal} className="WarrantyExportModal__export-modal-close-button">
              <div className="WarrantyExportModal__export-modal-close-button-container">
                <Icon className="xmark" size="big" />
              </div>
            </Button>
          </div>
        </div>
      </Modal.Header>
      <Modal.Actions>
        <div className="WarrantyExportModal__export-modal-content-text">
          {isPending && `${t("v8_loading", "Loading")}...`}
          {isSuccess && t("v8_export_queued", "Export queued for download. You will receive a notification when ready.")}
          {isError && t("v8_something_went_wrong", "Something went wrong, please contact the administrator")}
        </div>
      </Modal.Actions>
    </Modal>
  );
};
